import { Modal } from 'react-bootstrap';

function ModalWrapper({
  show,
  handleClose,
  children,
  title,
  size = 'lg',
  position = 'centered',
  className = '',
}: {
  show: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  title?: string;
  className?: string;
  size?: any;
  position?: 'centered' | 'bottom' | 'top';
}) {
  return (
    <>
      <Modal
        centered={position === 'centered'}
        show={show}
        onHide={handleClose}
        size={size}
      >
        <Modal.Header className={title ? '' : 'border-0'} closeButton>
          {title && <Modal.Title>{title}</Modal.Title>}
        </Modal.Header>
        <Modal.Body className={className}>{children}</Modal.Body>
      </Modal>
    </>
  );
}

export default ModalWrapper;
